import { SvgProps } from 'models/svg';

const PhoneSvg = ({ className }: SvgProps) => {
  return (
    <svg width='14' height='13' viewBox='0 0 14 13' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
      <path
        d='M4.75 1.08594L5.71094 3.35938C5.875 3.75781 5.75781 4.20312 5.42969 4.46094L4.39844 5.30469C5.14844 6.99219 6.48438 8.35156 8.125 9.17188L9.03906 8.07031C9.29688 7.74219 9.74219 7.625 10.1406 7.78906L12.4141 8.75C12.8594 8.9375 13.0938 9.40625 12.9766 9.875L12.9297 9.99219C12.5312 11.5156 11.0547 12.8047 9.27344 12.4297C5.17188 11.5625 1.9375 8.32812 1.07031 4.22656C0.695312 2.44531 1.98438 0.992188 3.50781 0.570312L3.625 0.523438C4.09375 0.40625 4.5625 0.640625 4.75 1.08594Z'
        fill='#6C727F'
      />
    </svg>
  );
};

export default PhoneSvg;
